import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// 캐시 방지 및 새 버전 배포 시 자동 새로고침 처리
const checkVersionAndRefresh = () => {
  const currentBuildTime = import.meta.env.VITE_BUILD_TIME;
  const savedBuildTime = localStorage.getItem('app_build_time');

  if (currentBuildTime && savedBuildTime && savedBuildTime !== currentBuildTime) {
    localStorage.setItem('app_build_time', currentBuildTime);
    // 새로운 빌드가 배포되었을 때 캐시 삭제 및 새로고침
    if ('caches' in window) {
      caches.keys().then((names) => {
        names.forEach((name) => caches.delete(name));
      });
    }
    window.location.reload();
    return;
  } else if (currentBuildTime) {
    localStorage.setItem('app_build_time', currentBuildTime);
  }
};

checkVersionAndRefresh();

// Vite 동적 청크 모듈 로드 실패 시(새 배포 후 구버전 파일 요청 에러) 자동 새로고침
window.addEventListener('vite:preloadError', () => {
  window.location.reload();
});

// 모바일 확대/축소 및 화면 흔들림(Pinch zoom, Gesture zoom, Double tap zoom) 차단
if (typeof window !== 'undefined') {
  document.addEventListener('gesturestart', (e) => e.preventDefault());
  document.addEventListener('gesturechange', (e) => e.preventDefault());
  document.addEventListener('gestureend', (e) => e.preventDefault());

  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches && e.touches.length > 1) {
        e.preventDefault();
      }
    },
    { passive: false }
  );

  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) {
        const target = e.target as HTMLElement;
        if (!['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON', 'A', 'LABEL'].includes(target?.tagName || '')) {
          e.preventDefault();
        }
      }
      lastTouchEnd = now;
    },
    { passive: false }
  );
}

const rootElement = document.getElementById('root');
if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}